var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    zoomAndPan: "magnify",
    viewBox: "0 0 768 767.999994",
    height: 1024,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3b1720d48a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 231 242.304688 L 515 242.304688 L 515 525.804688 L 231 525.804688 Z M 231 242.304688 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c2120",
    d: "M 336.828125 429.996094 L 367.917969 465.398438 L 369.023438 466.648438 L 536.886719 319.167969 L 504.679688 282.515625 L 372.933594 398.269531 L 326.988281 345.992188 L 290.867188 377.71875 Z M 336.828125 429.996094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3b1720d48a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1c2120",
    d: "M 479.050781 490.265625 L 266.511719 490.265625 L 266.511719 277.726562 L 479.050781 277.726562 L 479.050781 283.792969 L 508.449219 258.023438 C 502.097656 248.546875 491.3125 242.304688 479.050781 242.304688 L 266.511719 242.304688 C 246.949219 242.304688 231.089844 258.164062 231.089844 277.726562 L 231.089844 490.265625 C 231.089844 509.820312 246.949219 525.6875 266.511719 525.6875 L 479.050781 525.6875 C 498.613281 525.6875 514.472656 509.820312 514.472656 490.265625 L 514.472656 359.816406 L 479.050781 390.9375 Z M 479.050781 490.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.ea0540437e339f0b54dfbc06d993a95e.svg";
export { ForwardRef as ReactComponent };